module.exports = __webpack_public_path__ + "assets/images/team-away-logo-placeholder.86b0ad472576d325d6474ac78fe15da1.png";